import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import CranksetFiltersLength from '@/components/setup/crankset/CranksetFiltersLength.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CranksetHardware',
  setup(__props) {

const { t } = useI18n()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)

const lengthFilter = ref(false)

const toggleFilter = () => {
  lengthFilter.value = !lengthFilter.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfAccordion), {
    title: _unref(t)('setup.parts.crankset'),
    "open-by-default": lengthFilter.value
  }, {
    "header-right": _withCtx(() => [
      (!lengthFilter.value)
        ? (_openBlock(), _createBlock(_unref(BfButton), {
            key: 0,
            type: _unref(ButtonType).Outlined,
            onClick: _withModifiers(toggleFilter, ["stop"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('common.change')), 1)
            ]),
            _: 1
          }, 8, ["type"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(BfBadge), {
        color: 
          _unref(selectedMeasurement)?.crankset.active !== undefined
            ? _unref(Colors).Success
            : _unref(Colors).Danger
        
      }, null, 8, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.crankset.length')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.crankset.active
          ? `${_unref(selectedMeasurement)?.crankset.active} ${_unref(t)('common.unit.mm')}`
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      (lengthFilter.value)
        ? (_openBlock(), _createBlock(CranksetFiltersLength, {
            key: 0,
            onCancel: toggleFilter,
            onSave: toggleFilter
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "open-by-default"]))
}
}

})